﻿/// <reference path="../../Scripts/TypeScript/angularjs/angular.d.ts"/>
/// <reference path="../../Decorators.ts" />

namespace Umbrella.Search.Complexes {
    angular.module('Search').config([
        '$stateProvider',
        $stateProvider => {
            $stateProvider.state('search.complexes', {
                url: '/complexen?query',
                data: {
                    pageTitle: 'Complexen',
                    authorize: ps => ps.customerCard
                },
                views: {
                    'center@search': {
                        templateUrl: '/Search/_Complexes/ComplexOverview.html',
                        controller: ComplexOverviewController
                    }
                }
            });
        }
    ]);
}
